export interface NewsItem {
  id: string;
  title: string;
  summary: string;
  content: string[];
  cover: string;
  date: string;
  category: "news" | "activity" | "life";
  subCategory: string;
  source: string;
  author: string;
  tags: string[];
  featured?: boolean;
}

export const newsList: NewsItem[] = [
  {
    id: "n1001",
    title: "小泽玛利亚亮相年度粉丝见面会，与现场粉丝暖心互动",
    summary:
      "在刚刚结束的年度粉丝见面会上，小泽玛利亚以全新造型登场，与来自各地的粉丝近距离交流，并分享了未来的工作计划。",
    content: [
      "在本次年度粉丝见面会上，小泽玛利亚以一袭温柔的粉色调造型亮相，现场气氛从一开始就被点燃。她主动走到观众席前，与粉丝逐一击掌互动，感谢大家一路以来的陪伴。",
      "谈及近况时，她表示过去一年把更多精力放在了作品打磨与个人状态调整上，希望以更好的面貌回馈支持自己的人。她也透露，接下来会尝试更多不同类型的角色。",
      "见面会尾声，她为粉丝准备了手写卡片作为惊喜礼物，并清唱了一段歌曲，让不少粉丝直呼“太用心了”。",
    ],
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20pink%20toned%20elegant%20fan%20meeting%20stage%20with%20soft%20spotlights%20and%20floral%20decorations%2C%20bright%20clean%20atmosphere%2C%20editorial%20photography%2C%20no%20text&width=800&height=600&seq=news-1001&orientation=landscape",
    date: "2026-10-08",
    category: "activity",
    subCategory: "见面会",
    source: "本站编辑",
    author: "资讯组",
    tags: ["见面会", "粉丝互动", "行程"],
    featured: true,
  },
  {
    id: "n1002",
    title: "新作开拍在即，小泽玛利亚挑战全新角色类型",
    summary:
      "据悉，小泽玛利亚已确认出演一部全新作品，将在其中挑战与以往风格不同的角色，目前剧组已进入紧张的前期筹备。",
    content: [
      "多方消息确认，小泽玛利亚已确定加盟一部全新作品，并将出演与过往形象有一定反差的角色。制作团队表示，这个角色需要更多细腻的情绪表达，非常适合她现阶段的状态。",
      "为准备角色，她近期已经开始进行台词与肢体训练的专项课程，并主动与导演多次沟通人物设定，希望呈现更有层次的表现。",
      "作品预计将在年内正式开拍，具体上映信息以官方公布为准。本站将持续跟进后续进展。",
    ],
    cover:
      "https://readdy.ai/api/search-image?query=Modern%20film%20set%20with%20camera%20and%20softbox%20lighting%2C%20blush%20pink%20and%20cream%20tones%2C%20minimal%20clean%20studio%2C%20editorial%20cinematic%20photography%2C%20no%20text&width=800&height=600&seq=news-1002&orientation=landscape",
    date: "2026-10-02",
    category: "news",
    subCategory: "作品资讯",
    source: "本站编辑",
    author: "资讯组",
    tags: ["新作", "开拍", "角色"],
    featured: true,
  },
  {
    id: "n1003",
    title: "写真集第三弹正式官宣，主打自然光与生活感",
    summary:
      "官方宣布，小泽玛利亚写真集第三弹将于年底发行，本次拍摄以自然光与生活场景为主，呈现更放松的一面。",
    content: [
      "官方于本周正式公开了写真集第三弹的主视觉，画面中她身着柔和色调服饰，在自然光下呈现出放松自然的状态。",
      "据团队介绍，本次拍摄选址包括海边与老城区，希望用更生活化的镜头记录她的日常气质，弱化刻意摆拍的感觉。",
      "写真集将于年底正式发行，先行预约通道会在官方渠道开放，喜欢的朋友可以留意后续公告。",
    ],
    cover:
      "https://readdy.ai/api/search-image?query=Soft%20natural%20light%20photography%20set%20with%20linen%20textiles%20and%20dried%20flowers%2C%20warm%20cream%20and%20pink%20tones%2C%20cozy%20minimal%20interior%2C%20editorial%2C%20no%20text&width=800&height=600&seq=news-1003&orientation=landscape",
    date: "2026-09-26",
    category: "life",
    subCategory: "写真更新",
    source: "官方资讯",
    author: "资讯组",
    tags: ["写真集", "发行", "预告"],
    featured: true,
  },
  {
    id: "n1004",
    title: "参与公益探访活动，为儿童关爱计划发声",
    summary:
      "小泽玛利亚日前参与了儿童关爱主题的公益探访活动，并在社交平台呼吁大家关注相关议题。",
    content: [
      "在本次公益探访活动中，小泽玛利亚与志愿者一同走访了社区儿童关爱中心，了解孩子们的日常学习与生活状况。",
      "她表示，看到孩子们的笑容让自己很受触动，也希望用自己的影响力让更多人关注到这些需要帮助的群体。",
      "活动方对她的参与表达了感谢，并透露后续还会有更多合作计划。",
    ],
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20community%20charity%20visit%20scene%20with%20soft%20daylight%20and%20plants%2C%20gentle%20pink%20and%20cream%20palette%2C%20hopeful%20clean%20editorial%20photography%2C%20no%20text&width=800&height=600&seq=news-1004&orientation=landscape",
    date: "2026-09-18",
    category: "activity",
    subCategory: "公益行程",
    source: "本站编辑",
    author: "资讯组",
    tags: ["公益", "儿童关爱", "行程"],
  },
  {
    id: "n1005",
    title: "品牌合作再添新成员，代言广告花絮抢先看",
    summary:
      "小泽玛利亚正式成为某护肤品牌的新一季代言人，官方同步释出拍摄花絮，展现清新粉嫩的一面。",
    content: [
      "本次合作中，她以清新自然的妆容出镜，配合柔和的粉色背景，整体视觉延续了品牌温柔治愈的调性。",
      "拍摄花絮里，她多次主动与工作人员沟通调整细节，专业态度获得现场团队一致好评。",
      "品牌方表示，选择她正是看中了她亲和、自然的公众形象，与产品定位高度契合。",
    ],
    cover:
      "https://readdy.ai/api/search-image?query=Beauty%20brand%20commercial%20shooting%20scene%20with%20pink%20backdrop%20and%20soft%20makeup%20products%2C%20clean%20bright%20studio%2C%20elegant%20editorial%20photography%2C%20no%20text&width=800&height=600&seq=news-1005&orientation=landscape",
    date: "2026-09-10",
    category: "news",
    subCategory: "演艺新闻",
    source: "品牌通告",
    author: "资讯组",
    tags: ["代言", "品牌合作", "花絮"],
  },
  {
    id: "n1006",
    title: "专访实录：关于成长、作品与未来的坦诚分享",
    summary:
      "在一则深度专访中，小泽玛利亚回顾了自己的成长历程，并坦诚聊到了对作品和未来规划的想法。",
    content: [
      "谈到成长，她说这些年最大的变化是学会了与自己相处，也更清楚自己想呈现给观众的是什么。",
      "对于作品，她坦言会更在意角色是否“有话说”，而不是单纯追求数量，“希望每一次出现都有意义”。",
      "至于未来，她希望在合适的时机尝试幕后工作，把经验分享给更多新人。",
    ],
    cover:
      "https://readdy.ai/api/search-image?query=Calm%20interview%20setting%20with%20soft%20window%20light%20and%20minimal%20pink%20chair%2C%20warm%20neutral%20tones%2C%20thoughtful%20editorial%20portrait%20scene%2C%20no%20text&width=800&height=600&seq=news-1006&orientation=landscape",
    date: "2026-08-30",
    category: "news",
    subCategory: "演艺新闻",
    source: "本站专访",
    author: "记者 林悦",
    tags: ["专访", "成长", "未来规划"],
  },
  {
    id: "n1007",
    title: "夏日主题活动圆满落幕，现场花絮大放送",
    summary:
      "为期两天的夏日主题活动顺利结束，小泽玛利亚与粉丝共同度过了充满笑声的周末。",
    content: [
      "活动当天虽有小雨，但粉丝热情不减，现场早早便排起了长队。她特意提前到场与工作人员确认流程。",
      "互动环节中，她与粉丝一起完成了多个趣味游戏，全程笑声不断，也多次暖心提醒大家注意防暑。",
      "活动结束时，她在社交平台发文感谢所有到场的朋友，并预告下一次见面不会太远。",
    ],
    cover:
      "https://readdy.ai/api/search-image?query=Summer%20outdoor%20fan%20event%20with%20festive%20decorations%20and%20soft%20evening%20light%2C%20warm%20pink%20and%20cream%20palette%2C%20lively%20clean%20editorial%20photography%2C%20no%20text&width=800&height=600&seq=news-1007&orientation=landscape",
    date: "2026-08-15",
    category: "activity",
    subCategory: "见面会",
    source: "本站编辑",
    author: "资讯组",
    tags: ["夏日活动", "花絮", "见面会"],
  },
  {
    id: "n1008",
    title: "日常分享：一杯咖啡与一本好书的午后",
    summary:
      "小泽玛利亚在社交平台分享了自己的午后时光，安静惬意的氛围引来粉丝纷纷留言。",
    content: [
      "照片中，她坐在窗边，桌上放着一杯咖啡和一本读到一半的书，阳光透过窗帘洒下来，画面十分安静。",
      "她配文写道，忙碌之余最喜欢这样的时刻，“让大脑慢下来，也是一种充电”。",
      "不少粉丝在评论区分享了自己的读书清单，气氛温馨友好。",
    ],
    cover:
      "https://readdy.ai/api/search-image?query=Cozy%20afternoon%20window%20seat%20with%20a%20cup%20of%20coffee%20and%20an%20open%20book%2C%20soft%20sunlight%2C%20warm%20pink%20cream%20tones%2C%20minimal%20lifestyle%20photography%2C%20no%20text&width=800&height=600&seq=news-1008&orientation=landscape",
    date: "2026-08-04",
    category: "life",
    subCategory: "日常花絮",
    source: "社交平台",
    author: "资讯组",
    tags: ["日常", "生活", "分享"],
  },
  {
    id: "n1009",
    title: "官方周边新品上架，限定款引发抢购热潮",
    summary:
      "官方周边商店本周上新，多款限定周边在上架当天便被抢购一空，官方表示将追加补货。",
    content: [
      "本次上新的周边包括亚克力立牌、帆布包与拍立得卡片套装，设计延续了温柔粉色系风格。",
      "上架当天，部分限定款在短时间内售罄，官方随后宣布将追加补货并优化购买流程。",
      "不少粉丝表示希望未来能推出更多实用型周边，官方回应会认真考虑相关建议。",
    ],
    cover:
      "https://readdy.ai/api/search-image?query=Cute%20pink%20merchandise%20flat%20lay%20with%20acrylic%20standee%20and%20canvas%20bag%20on%20cream%20background%2C%20clean%20bright%20product%20photography%2C%20no%20text&width=800&height=600&seq=news-1009&orientation=landscape",
    date: "2026-07-22",
    category: "news",
    subCategory: "演艺新闻",
    source: "官方商店",
    author: "资讯组",
    tags: ["周边", "限定", "上架"],
  },
  {
    id: "n1010",
    title: "生日应援企划公布，粉丝自发组织暖心活动",
    summary:
      "随着生日临近，粉丝团体公布了今年的应援企划，包括公益捐赠与线下主题展。",
    content: [
      "今年粉丝应援以“温暖与陪伴”为主题，除了常规的线下主题展，还发起了以她名义的公益捐赠。",
      "组织方表示，希望把对偶像的喜欢转化为更有意义的行动，这也是她本人一直倡导的方向。",
      "相关线下展览将在本月底开放，具体时间与地点会在粉丝社区同步更新。",
    ],
    cover:
      "https://readdy.ai/api/search-image?query=Birthday%20fan%20support%20exhibition%20with%20pink%20balloons%20and%20warm%20fairy%20lights%2C%20soft%20cream%20background%2C%20festive%20clean%20editorial%20photography%2C%20no%20text&width=800&height=600&seq=news-1010&orientation=landscape",
    date: "2026-07-10",
    category: "activity",
    subCategory: "品牌活动",
    source: "粉丝社区",
    author: "资讯组",
    tags: ["生日应援", "公益", "线下展"],
  },
  {
    id: "n1011",
    title: "幕后vlog上线，记录一天的工作日常",
    summary:
      "工作室发布了最新幕后vlog，完整记录了小泽玛利亚从清晨准备到深夜收工的一天。",
    content: [
      "vlog从清晨的妆发准备开始，镜头里的她一边吃早餐一边看剧本，状态轻松。",
      "白天是紧凑的拍摄日程，她在片场多次与工作人员确认细节，休息间隙也不忘给大家加油打气。",
      "视频结尾，她笑着说“今天也很充实”，并感谢每一位默默付出的工作人员。",
    ],
    cover:
      "https://readdy.ai/api/search-image?query=Behind%20the%20scenes%20vlog%20scene%20with%20makeup%20mirror%20and%20soft%20warm%20light%2C%20pink%20and%20cream%20tones%2C%20candid%20editorial%20photography%2C%20no%20text&width=800&height=600&seq=news-1011&orientation=landscape",
    date: "2026-06-28",
    category: "life",
    subCategory: "日常花絮",
    source: "工作室",
    author: "资讯组",
    tags: ["vlog", "幕后", "工作日常"],
  },
  {
    id: "n1012",
    title: "客串特别企划短片，惊喜登场引热议",
    summary:
      "在一档特别企划短片中，小泽玛利亚以客串身份惊喜登场，短短几分钟的戏份引发观众热烈讨论。",
    content: [
      "该短片以都市生活为背景，她在其中饰演一位温柔而坚定的关键人物，戏份不多但十分亮眼。",
      "播出后，相关片段在社交平台被大量转发，不少观众表示“完全没看够”。",
      "制作方透露，未来不排除为该角色开发更完整的故事线。",
    ],
    cover:
      "https://readdy.ai/api/search-image?query=Urban%20short%20film%20scene%20with%20soft%20neon%20and%20pink%20tones%2C%20modern%20city%20evening%2C%20cinematic%20editorial%20photography%2C%20no%20text&width=800&height=600&seq=news-1012&orientation=landscape",
    date: "2026-06-12",
    category: "news",
    subCategory: "作品资讯",
    source: "本站编辑",
    author: "资讯组",
    tags: ["客串", "短片", "热议"],
  },
];

export function getNewsById(id: string): NewsItem | undefined {
  return newsList.find((item) => item.id === id);
}

export function getFeaturedNews(): NewsItem[] {
  return newsList.filter((item) => item.featured).slice(0, 5);
}

export function getRelatedNews(current: NewsItem, limit = 4): NewsItem[] {
  return newsList
    .filter((item) => item.id !== current.id)
    .sort((a, b) => {
      const aScore = a.category === current.category ? 1 : 0;
      const bScore = b.category === current.category ? 1 : 0;
      if (aScore !== bScore) return bScore - aScore;
      return b.date.localeCompare(a.date);
    })
    .slice(0, limit);
}